import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Reads a feature flag using the security-definer `flag_enabled(_key, _org)` RPC.
 * Cached for 60s to avoid re-fetching on every route change.
 */
export function useFeatureFlag(key: string, orgId?: string | null) {
  return useQuery({
    queryKey: ["feature_flag", key, orgId ?? null],
    queryFn: async () => {
      const { data, error } = await (supabase.rpc as any)("flag_enabled", {
        _key: key,
        _org: orgId ?? null,
      });
      if (error) throw error;
      return Boolean(data);
    },
    staleTime: 60_000,
  });
}
